import React from 'react'

import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import CruiseVerticalUSPs from 'components/Cruises/CruiseOfferPage/content/BookWithConfidence/CruiseVerticalUSPs'
import { useIntl } from 'react-intl'

function CruisePageUSPsSection() {
  const intl = useIntl()
  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group direction="vertical" gap={20}>
        <Heading variant="heading3">
          {intl.formatMessage({
            id: '8oyIPo1bCl',
            defaultMessage: 'Why you should book with us',
            description: 'Heading for why book with us section',
          })}
        </Heading>

        <CruiseVerticalUSPs />
      </Group>
    </LayoutContainer>
  </Group>
}

export default CruisePageUSPsSection
